import { apiPost } from './apiClient';
import { addReportToServer, secondsToHMS } from '../functions/sendReport';
import { writeStoredElapsedSeconds } from '../hooks/useCarnivalTimer';

/**
 * checkCoins → saveScore → ExtraMile report on first attempt only.
 */
export async function finishGame({ user, gameKey, score, elapsedSeconds = 0 }) {
  const elapsed = Math.max(0, Math.floor(Number(elapsedSeconds) || 0));
  const time = secondsToHMS(elapsed);
  const check = await apiPost('/game/checkCoins', {
    userId: user.userId,
    gameKey,
    score,
  });

  const saved = await apiPost('/game/saveScore', {
    userId: user.userId,
    gameKey,
    score,
    time,
    name: user.name || user.firstName || '',
    email: user.email || '',
  });

  const alreadyPlayed = Boolean(check.alreadyPlayed);
  const coinsEarned = alreadyPlayed ? 0 : Math.max(0, Number(check.coinsEarned) || 0);

  if (!alreadyPlayed) {
    writeStoredElapsedSeconds(elapsed, user.userId, user.sessionId);
    await addReportToServer(user, {
      points: saved.coins_left ?? coinsEarned,
      reportTime: time,
      answers: [gameKey, String(score)],
      preferReportId: saved.reportid || user.reportId || null,
    });
  }

  return {
    coinsEarned,
    coins_left: saved.coins_left,
    alreadyPlayed,
  };
}
